import {
  Tabs,
  Button,
  Table,
  Popconfirm,
  Row,
  Col,
  Modal,
  Drawer,
  Transfer,
  Space,
  Tooltip,
  Input,
  message,
  Skeleton,
  Alert,
} from 'antd';
import types from 'html2canvas';
import { cloneDeep } from 'lodash';
import { getClient } from '../../apollo';
import {
  GetAllClientsQueryResult,
  GetARateDocument,
  GetARateQuery,
  GetARateQueryResult,
  GetARateQueryVariables,
  useAssignClientsToRateMutation,
  useDeleteVehiclePriceVariableMutation,
  useDisassignClientsFromRateMutation,
  useGetAllClientsQuery,
  useGetARateQuery,
  useUpdateARateMutation,
  useGetVehicleBrandModelsQuery,
  useVehicleTypesQuery,
} from '../../graphql/datamodel.gen';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import VehicleCategories from './VehicleCategories/VehicleCategories';
import { useState } from 'react';
import { SubtypeModal } from './subtypeModal';
import { PricesTableModal } from './pricesTableModal';
import { VariablesModal } from './variablesModal';
import { TransferDirection, TransferListProps } from 'antd/lib/transfer';
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  LoadingOutlined,
  ReloadOutlined,
  EditOutlined,
} from '@ant-design/icons';

const { TabPane } = Tabs;

interface SingleRateProps {
  id: string;
  visible: boolean;
  onClose: () => void;
}

type VehiclePriceVariableRow =
  GetARateQuery['rate']['vehiclePriceVariables'][0];

export const SingleRateModal: React.FC<SingleRateProps> = (
  props: SingleRateProps,
) => {
  const [editingName, setEditingName] = useState<string | boolean>(false);
  const [selectedClientId, setSelectedClientId] = useState(undefined);
  const [selectedServiceType, setSelectedServiceType] = useState(undefined);
  const [selectedServiceSubType, setSelectedServiceSubType] =
    useState(undefined);
  const [priceTableVisible, setPriceTableVisible] = useState(false);
  const [managementVisible, setManagementVisible] = useState(false);

  const [variablesVisble, setVariablesVisible] = useState(false);
  const [variable, setVariable] = useState(undefined);

  const getRateResult = useGetARateQuery({
    client: getClient(),
    variables: {
      id: props.id,
    },
    fetchPolicy: 'cache-and-network',
    skip: !props.id,
  });

  const updateRateMut = useUpdateARateMutation({
    client: getClient(),
  });

  const clientsQuery = useGetAllClientsQuery({
    client: getClient(),
    notifyOnNetworkStatusChange: true,
  });

  const vehicleTypesQuery = useVehicleTypesQuery({
    client: getClient(),
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const vehicleBrandModelsQuery = useGetVehicleBrandModelsQuery({
    client: getClient(),
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const [deleteVehiclePriceMut] = useDeleteVehiclePriceVariableMutation({
    client: getClient(),
    notifyOnNetworkStatusChange: true,
  });

  const assignClientsToRateMut = useAssignClientsToRateMutation({
    client: getClient(),
    notifyOnNetworkStatusChange: true,
  });

  const disassignClientsToRateMut = useDisassignClientsFromRateMutation({
    client: getClient(),
    notifyOnNetworkStatusChange: true,
  });

  const allModels = [];

  vehicleBrandModelsQuery?.data?.vehicleBrandModels.forEach((brand) => {
    const { models } = brand;
    allModels.push(...models);
  });

  const subtypes =
    getRateResult.data?.rate?.serviceTypes?.find(
      (serviceType) => serviceType.id === selectedServiceType,
    )?.subtypes || [];

  const types =
    getRateResult.data?.rate?.serviceTypes?.filter(
      (type) => type.subtypes?.length,
    ) || [];

  const selectedSubtype = subtypes.find(
    (subtype) => subtype.id === selectedServiceSubType,
  );

  const renderFooter = (
    _: TransferListProps<any>,
    {
      direction,
    }: {
      direction: TransferDirection;
    },
  ) => {
    if (direction === 'left') {
      return (
        <Space direction="horizontal" style={{ margin: 5 }}>
          <Button
            size="small"
            onClick={() => {
              clientsQuery.refetch();
            }}
            loading={clientsQuery.loading}
            icon={<ReloadOutlined translate={undefined} />}
          >
            Refrescar
          </Button>
          {/* <Button
            icon={<ArrowRightOutlined translate={undefined} />}
            size="small"
          >
            Asignar todos
          </Button> */}
        </Space>
      );
    }
    // return (
    //   <Button
    //     size="small"
    //     icon={<ArrowLeftOutlined translate={undefined} />}
    //     style={{ float: 'right', margin: 5 }}
    //     // onClick={getMock}
    //   >
    //     Desasignar todos
    //   </Button>
    // );
  };

  return (
    <Drawer
      destroyOnClose
      forceRender
      title={
        getRateResult.networkStatus === 1 ? null : !editingName ? (
          <div>
            {getRateResult.data?.rate?.name}{' '}
            <Tooltip title="Edita el título de este tarifario">
              <Button
                type="text"
                icon={<EditOutlined translate={undefined} />}
                onClick={() => {
                  setEditingName(true);
                }}
              />
            </Tooltip>
          </div>
        ) : (
          <Input.Group compact>
            <Input
              style={{ width: 300 }}
              autoFocus
              defaultValue={getRateResult.data?.rate?.name}
              onChange={(event) => {
                setEditingName(event.target.value);
              }}
            />
            {typeof editingName === 'string' &&
              editingName !== getRateResult.data?.rate?.name && (
                <Button
                  loading={updateRateMut[1].loading}
                  type="primary"
                  // disabled={typeof editingName !== 'boolean'}
                  onClick={() => {
                    updateRateMut[0]({
                      variables: {
                        rate: getRateResult.data?.rate?.id,
                        name: editingName as string,
                      },
                      onCompleted: () => {
                        message.success('Nombre actualizado correctamente');
                        setEditingName(false);
                      },
                    });
                  }}
                >
                  Listo
                </Button>
              )}
            <Button
              onClick={() => {
                setEditingName(false);
              }}
            >
              Cancelar
            </Button>
          </Input.Group>
          // <Input autoFocus />
        )
      }
      visible={props.visible}
      width="100%"
      onClose={props.onClose}
    >
      {getRateResult.networkStatus === 1 && (
        <Skeleton loading={true} active={true} />
      )}
      <Tabs type="card" hidden={getRateResult.networkStatus === 1}>
        <Tabs.TabPane tab="Propiedades" key="1">
          <Tabs type="card">
            <TabPane tab="Según vehículo" key="1">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  marginBottom: '1rem',
                }}
              >
                <Button
                  type="primary"
                  icon={<LegacyIcon type={'plus'} />}
                  onClick={() => {
                    setVariablesVisible(true);
                  }}
                >
                  Añadir configuración
                </Button>
              </div>
              <Table
                pagination={false}
                bordered
                size="small"
                dataSource={[
                  ...(getRateResult.data?.rate?.vehiclePriceVariables || []),
                ]}
                columns={[
                  {
                    title: 'Tipo',
                    key: 'type',
                    render: (_: any, record) => {
                      return vehicleTypesQuery?.data?.vehicleTypes
                        ?.find((type) => type.id === record.vehicleTypeId)
                        ?.name?.toUpperCase();
                    },
                    defaultSortOrder: 'ascend',
                    sorter: (
                      recordA: VehiclePriceVariableRow,
                      recordB: VehiclePriceVariableRow,
                    ) => {
                      const nameA = vehicleTypesQuery?.data?.vehicleTypes
                        ?.find((type) => type.id === recordA.vehicleTypeId)
                        ?.name?.toUpperCase();

                      const nameB = vehicleTypesQuery?.data?.vehicleTypes
                        ?.find((type) => type.id === recordB.vehicleTypeId)
                        ?.name?.toUpperCase();

                      return nameA?.localeCompare(nameB);
                    },
                  },
                  {
                    title: 'Marca',
                    key: 'brand',
                    render: (_: any, record) => {
                      return vehicleBrandModelsQuery?.data?.vehicleBrandModels
                        ?.find((brand) => brand.id === record.vehicleBrandId)
                        ?.brand?.toUpperCase();
                    },
                    defaultSortOrder: 'ascend',
                    sorter: (
                      recordA: VehiclePriceVariableRow,
                      recordB: VehiclePriceVariableRow,
                    ) => {
                      const nameA =
                        vehicleBrandModelsQuery?.data?.vehicleBrandModels
                          ?.find((brand) => brand.id === recordA.vehicleBrandId)
                          ?.brand?.toUpperCase();

                      const nameB =
                        vehicleBrandModelsQuery?.data?.vehicleBrandModels
                          ?.find((brand) => brand.id === recordB.vehicleBrandId)
                          ?.brand?.toUpperCase();

                      return nameA?.localeCompare(nameB);
                    },
                  },
                  {
                    title: 'Modelo',
                    key: 'model',
                    render: (_: any, record) => {
                      return allModels
                        .find((model) => model.id === record.vehicleModelId)
                        ?.name?.toUpperCase();
                    },
                    defaultSortOrder: 'ascend',
                    sorter: (
                      recordA: VehiclePriceVariableRow,
                      recordB: VehiclePriceVariableRow,
                    ) => {
                      const nameA = allModels
                        .find((model) => model.id === recordA.vehicleModelId)
                        ?.name?.toUpperCase();

                      const nameB = allModels
                        .find((model) => model.id === recordB.vehicleModelId)
                        ?.name?.toUpperCase();

                      return nameA?.localeCompare(nameB);
                    },
                  },
                  {
                    title: 'Capacidad (PAX)',
                    dataIndex: 'paxNumber',
                    render: (capacity: number) => {
                      if (capacity === 0) {
                        return null;
                      }

                      return capacity;
                    },
                    sorter: (
                      recordA: VehiclePriceVariableRow,
                      recordB: VehiclePriceVariableRow,
                    ) => {
                      return recordA.paxNumber || 0 - recordB.paxNumber || 0;
                    },
                  },
                  {
                    title: 'Kilómetro extra',
                    dataIndex: 'extraPricePerKm',
                    render: (value: number) => {
                      return `${value} €`;
                    },
                    sorter: (
                      recordA: VehiclePriceVariableRow,
                      recordB: VehiclePriceVariableRow,
                    ) => {
                      return (
                        recordA.extraPricePerKm ||
                        0 - recordB.extraPricePerKm ||
                        0
                      );
                    },
                  },
                  {
                    title: 'Peaje extra',
                    dataIndex: 'tollPricePerKm',
                    render: (value: number) => {
                      return `${value} €`;
                    },
                    sorter: (
                      recordA: VehiclePriceVariableRow,
                      recordB: VehiclePriceVariableRow,
                    ) => {
                      return (
                        recordA.tollPricePerKm ||
                        0 - recordB.tollPricePerKm ||
                        0
                      );
                    },
                  },
                  {
                    title: 'Asistencia aeropuerto',
                    dataIndex: 'airportPrice',
                    render: (value: number) => {
                      return `${value} €`;
                    },
                    sorter: (
                      recordA: VehiclePriceVariableRow,
                      recordB: VehiclePriceVariableRow,
                    ) => {
                      return (
                        recordA.airportPrice || 0 - recordB.airportPrice || 0
                      );
                    },
                  },
                  {
                    title: 'Parking Montserrat',
                    dataIndex: 'parkingMontserrat',
                    render: (value: number) => {
                      return `${value} €`;
                    },
                    sorter: (
                      recordA: VehiclePriceVariableRow,
                      recordB: VehiclePriceVariableRow,
                    ) => {
                      return (
                        recordA.parkingMontserrat ||
                        0 - recordB.parkingMontserrat ||
                        0
                      );
                    },
                  },
                  {
                    title: 'Hora extra',
                    dataIndex: 'extraHourPrice',
                    render: (value: number) => {
                      return `${value} €`;
                    },
                    sorter: (
                      recordA: VehiclePriceVariableRow,
                      recordB: VehiclePriceVariableRow,
                    ) => {
                      return (
                        recordA.extraHourPrice ||
                        0 - recordB.extraHourPrice ||
                        0
                      );
                    },
                  },
                  {
                    title: '',
                    key: 'actions',
                    render: (_: any, record) => {
                      return (
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <Button
                            style={{ marginRight: '15px' }}
                            onClick={() => {
                              setVariable(record);
                              setVariablesVisible(true);
                            }}
                          >
                            Gestionar
                          </Button>
                          <Popconfirm
                            title={'Estás seguro?'}
                            onConfirm={() => {
                              return deleteVehiclePriceMut({
                                variables: {
                                  id: record.id,
                                },
                                update: (proxy, mutationResult) => {
                                  try {
                                    const previousData = getClient().readQuery<
                                      GetARateQuery,
                                      GetARateQueryVariables
                                    >({
                                      query: GetARateDocument,
                                      variables: {
                                        id: getRateResult.data?.rate.id,
                                      },
                                    });

                                    const updatedRate = cloneDeep({
                                      ...previousData.rate,
                                      vehiclePriceVariables:
                                        previousData.rate.vehiclePriceVariables.filter(
                                          (pv) => pv.id !== record.id,
                                        ),
                                    });

                                    getClient().writeQuery<
                                      GetARateQuery,
                                      GetARateQueryVariables
                                    >({
                                      query: GetARateDocument,
                                      variables: {
                                        id: getRateResult.data?.rate.id,
                                      },
                                      id: getRateResult.data?.rate.id,
                                      data: {
                                        rate: updatedRate,
                                      },
                                    });

                                    // @ts-ignore
                                    getClient().queryManager.broadcastQueries();
                                  } catch (e) {
                                    console.error(e);
                                  }
                                },
                              });
                            }}
                          >
                            <Button danger>Eliminar</Button>
                          </Popconfirm>
                        </div>
                      );
                    },
                  },
                ]}
              />
            </TabPane>
            <TabPane tab="Según tipo de servicio" key="2">
              <Row>
                <Col span={8}>
                  <Table
                    bordered
                    pagination={false}
                    size="small"
                    rowSelection={{
                      fixed: true,
                      type: 'radio',
                      onSelect: (record) => {
                        setSelectedServiceType(record.id);
                      },
                      selectedRowKeys: [selectedServiceType],
                    }}
                    onRow={(record) => ({
                      onClick: () => {
                        setSelectedServiceType(record.id);
                      },
                    })}
                    columns={[
                      {
                        title: 'Tipo de servicio',
                        dataIndex: 'name',
                      },
                      {
                        title: 'Descripción',
                        dataIndex: 'description',
                      },
                      {
                        title: 'Subtipos',
                        render: (_: any, record) => {
                          return record.subtypes?.length || 0;
                        },
                      },
                    ]}
                    dataSource={[...types].map((t) => ({ ...t, key: t.id }))}
                  />
                </Col>
                <Col span={16}>
                  <Table
                    // onRowClick={record => {
                    //   setSelectedServiceSubType(record.id);
                    // }}
                    bordered
                    style={{ marginLeft: '15px' }}
                    pagination={false}
                    size="small"
                    // emptyText="Selecciona un tipo de servicio primero"
                    columns={[
                      {
                        title: 'Subtipo',
                        dataIndex: 'name',
                        sorter: (recordA, recordB) => {
                          return recordA.name?.localeCompare(recordB.name);
                        },
                        defaultSortOrder: 'ascend',
                      },
                      {
                        title: 'Descripción',
                        dataIndex: 'description',
                      },
                      {
                        title: '',
                        key: 'actions',
                        render: (_: any, record) => {
                          return (
                            <>
                              <Button
                                style={{ marginRight: '15px' }}
                                onClick={() => {
                                  setPriceTableVisible(true);
                                  setSelectedServiceSubType(record.id);
                                }}
                                icon={<LegacyIcon type={'euro'} />}
                              >
                                Precios
                              </Button>
                              <Button
                                onClick={() => {
                                  setSelectedServiceSubType(record.id);
                                  setManagementVisible(true);
                                }}
                              >
                                Gestionar
                              </Button>
                            </>
                          );
                        },
                      },
                    ]}
                    dataSource={[...subtypes]}
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Categorias de vehículos" key="3">
              <VehicleCategories rate={getRateResult.data?.rate} />
            </TabPane>
          </Tabs>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Clientes" key="2">
          <div>
            {getRateResult.data?.rate?.isGlobal && (
              <Alert message="Debido a que este es un tarifario por defecto, todos los clientes que no tengan un tarifario específico asignado, harán uso de este tarifario" />
            )}
            {!getRateResult.data?.rate?.isGlobal && (
              <Transfer
                titles={[
                  'Clientes sin asignar',
                  'Clientes asignados a este tarifario',
                ]}
                disabled={getRateResult.data?.rate?.isGlobal === true}
                // @ts-ignore
                // dataSource={clientsQuery.data?.clients.filter((c) => {
                //   return (
                //     !c.rate?.id || c.rate.id === getRateResult.data?.rate?.id
                //   );
                // })}
                dataSource={clientsQuery.data?.clients}
                render={(i) => i.name}
                listStyle={{
                  width: 400,
                  // height: '50%',
                }}
                pagination={{
                  pageSize: 10,
                }}
                // disabled={
                //   assignClientsToRateMut[1].loading ||
                //   disassignClientsToRateMut[1].loading ||
                //   clientsQuery.loading ||
                //   getRateResult.loading
                // }
                operations={['Asignar', 'Desasignar']}
                showSearch
                showSelectAll
                rowKey={(c) => c.volcanoClientId}
                // @ts-ignore
                footer={renderFooter}
                filterOption={(inputValue, item) => {
                  return (
                    item.name
                      ?.toLowerCase()
                      ?.includes(inputValue?.toLowerCase()) ||
                    inputValue
                      ?.toLowerCase()
                      ?.includes(item.name?.toLowerCase())
                  );
                }}
                targetKeys={getRateResult?.data?.rate?.clients?.map(
                  (c) => c.volcanoClientId,
                )}
                onChange={(targetKeys, direction, moveKeys) => {
                  const keys = moveKeys;

                  const clientsToMove = keys.reduce((prev, curr) => {
                    const matchingClient = clientsQuery.data?.clients?.find(
                      (c) => {
                        return c.id === curr || c.volcanoClientId === curr;
                      },
                    );

                    return [...prev, matchingClient];
                  }, []) as GetAllClientsQueryResult['data']['clients'];

                  if (direction === 'left') {
                    disassignClientsToRateMut[0]({
                      variables: {
                        clients: clientsToMove.map((c) => c.id),
                        rateId: getRateResult.data?.rate?.id,
                      },
                      onCompleted: () => {
                        // clientsQuery.refetch();
                        message.success('Clientes desasignados correctamente');
                        getRateResult.refetch();
                      },
                    });
                  }

                  if (direction === 'right') {
                    //assign
                    assignClientsToRateMut[0]({
                      variables: {
                        clients: clientsToMove.map((c) => c.id),
                        rateId: getRateResult.data?.rate?.id,
                      },
                      onCompleted: () => {
                        // clientsQuery.refetch();
                        message.success('Clientes asignados correctamente');
                        getRateResult.refetch();
                      },
                    });
                  }
                }}
              />
            )}
          </div>
        </Tabs.TabPane>
      </Tabs>

      <SubtypeModal
        rateId={getRateResult.data?.rate?.id}
        visible={managementVisible}
        onClose={() => {
          setManagementVisible(false);
          setSelectedServiceSubType(undefined);
        }}
        subtype={selectedSubtype}
      />
      <PricesTableModal
        clientId={selectedClientId}
        rateId={getRateResult.data?.rate?.id}
        refreshRate={getRateResult.refetch}
        visible={priceTableVisible}
        subtype={selectedSubtype}
        onClose={() => {
          setPriceTableVisible(false);
          setSelectedServiceSubType(undefined);
        }}
      />
      <VariablesModal
        clientId={selectedClientId}
        rateId={getRateResult.data?.rate?.id}
        visible={variablesVisble}
        variable={variable}
        onClose={() => {
          setVariablesVisible(false);
          setVariable(undefined);
        }}
      />
    </Drawer>
    // </Modal>
  );
};
